import React from "react";
import { fmtCurrencyFull, fmtPct } from "@/lib/format";
import { TrendingUp, ShieldCheck, AlertTriangle } from "lucide-react";

export default function ResultsSummary({ result }) {
  if (!result) return null;
  const s = result.summary;
  const successColor =
    s.success_probability_pct >= 85 ? "#348C59" :
    s.success_probability_pct >= 60 ? "#C9A227" : "#C26747";

  return (
    <div data-testid="results-summary" className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="bg-white border border-[#E5E2DC] rounded-2xl p-5">
        <div className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold">
          <ShieldCheck size={14} /> success probability
        </div>
        <div className="mt-3 font-display text-4xl font-mono-num" style={{ color: successColor }}>
          {fmtPct(result.summary.success_probability_pct, 1)}
        </div>
        <div className="text-xs text-[#5C6B62] mt-1">
          paths still solvent at age {result.inputs.life_expectancy}
        </div>
      </div>
      <div className="bg-white border border-[#E5E2DC] rounded-2xl p-5">
        <div className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold">
          <TrendingUp size={14} /> median final balance
        </div>
        <div className="mt-3 font-display text-2xl sm:text-3xl text-[#1C2B23] font-mono-num">
          {fmtCurrencyFull(s.median_final_balance)}
        </div>
        <div className="text-xs text-[#5C6B62] mt-1">
          p10 {fmtCurrencyFull(s.p10_final_balance)} · p90 {fmtCurrencyFull(s.p90_final_balance)}
        </div>
      </div>
      <div className="bg-white border border-[#E5E2DC] rounded-2xl p-5">
        <div className="flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold">
          <AlertTriangle size={14} /> stress test
        </div>
        <div className="mt-3 font-display text-2xl sm:text-3xl text-[#1C2B23] font-mono-num">
          {s.simulations_run.toLocaleString()}
        </div>
        <div className="text-xs text-[#5C6B62] mt-1">
          monte carlo runs across {s.years_projected} years
        </div>
      </div>
    </div>
  );
}
